export default {
  title: process.env.VUE_APP_CLIENT_FULL_NAME || "",
  description: process.env.VUE_APP_CLIENT_META_DESCRIPTION || "Répartiteur en médicaments & produits de santé",
};
